import React from 'react';
import LoadingPage from './LoadingPage';
import { Box, Container, Header } from '@amzn/awsui-components-core';

interface Props {
  headerText?: React.ReactNode;
  showLoadingIndicator?: boolean;
  children?: React.ReactNode;
}

const PageCanvas: React.FC<Props> = ({ showLoadingIndicator, headerText, children }) => {
  const header = headerText ? <Header variant="h3">{headerText}</Header> : null;

  return (
    <Box padding={{ top: 'xxl', horizontal: 'l' }} margin={{ bottom: 'm' }}>
      <Container disableContentPaddings header={header}>
        <Box padding={'xl'}>{showLoadingIndicator ? <LoadingPage /> : children}</Box>
      </Container>
    </Box>
  );
};

export default PageCanvas;
